import axios from "axios";

export default {
    login(userData) {
        return axios({
            method: "post",
            data: userData,
            url: process.env.VUE_APP_BASE_URL_CORE + "public/jwt/login",
            headers: {
                "X-CSRF-TOKEN": "",
            },
        });
    },
    register(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "public/register",
            headers: {
                "X-CSRF-TOKEN": "",
            },
        });
    },
    checkLogin(authentication) {
        return axios({
            method: "post",
            data: authentication,
            url: process.env.VUE_APP_BASE_URL_CORE + "public/jwt/authentication",
            headers: {
                "X-CSRF-TOKEN": "",
            },
        });
    },
    getRoles(authentication) {
        return axios({
            method: "post",
            data: authentication,
            url: process.env.VUE_APP_BASE_URL_CORE + "public/jwt/roles",
            headers: {
                "X-CSRF-TOKEN": "",
            },
        });
    },
};
